import { render } from "./Callback.vue?vue&type=template&id=616000e7&ts=true"
import script from "./Callback.vue?vue&type=script&lang=ts"
export * from "./Callback.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__